import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Routing from "./routes/routing.jsx";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from "react";


function App() {
  return (
    <div className="App">
      <Routing />
    </div>
  );
}

export default App;
